import React from 'react';
import DatePicker from 'react-pikaday-component';
import icon from '../img/info.svg';
import arrow from '../img/circle-arrow-left.svg';

const i18n = {
    previousMonth : 'Zurück',
    nextMonth     : 'Weiter',
    months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    weekdays      : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
    weekdaysShort : ['So','Mo','Di','Mi','Do','Fr','Sa']
}

class StartDateInput extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            choice: props.startDate
        }
    }

    render() {
        const props = this.props;
        const { choice } = this.state;

        return (
            <article className={`question q3 slide-${props.position}`}>
                <div className={`inner`}>
                    <div className="question__text">
                        <span>Seit wann besteht das Arbeitsverhältnis?</span>
                    </div>
                    <div className="question__field">
                        <DatePicker 
                            i18n={i18n}
                            firstDay={1}
                            position="top left"
                            format="DD.MM.YYYY"
                            maxDate={new Date()}
                            placeholder="TT.MM.JJJJ"
                            value={choice}
                            onChange={(day) => this.setState({ choice: day })}
                        />
                    </div>
                </div>
                <div className="inner question__controls">
                    <div className="question__control">
                        <a tabIndex="3"
                            className="question__back-link" 
                            onClick={props.showPreviousField}>
                                <img src={arrow} />
                        </a>
                    </div>
                    <div className="question__control">
                        <span data-tip data-for="start-date" className="question__info-icon">
                            <img src={icon} />
                        </span>
                    </div>
                    <div className="question__control">
                        <a tabIndex={ choice ? "2" : "-1" }
                            onClick={() => props.updateStartDate(choice)}
                            className={`question__next-link ${!choice ? 'hidden' : ''}`}>
                                <img src={arrow} />
                        </a>
                    </div>
                </div>
            </article>
        );
    }
}

export default StartDateInput;


// WEBPACK FOOTER //
// ./src/components/input.start-date.js